import React from 'react';
import { Grid, Divider, Typography, Link } from '@mui/material';
import { useApiGet } from '../../utils/httpClient';
import { getConversations } from '../../endpoints/messages';
import CircleIcon from '@mui/icons-material/Circle';
import dayjs from 'dayjs';
var utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

export default function Conversations() {
  const userId = localStorage.getItem('user_id');

  const { data: conversationsData, isFetching } = useApiGet(
    ['conversations', userId],
    getConversations,
    {
      enabled: userId !== null,
      retry: 1,
      refetchInterval: 60 * 1000, // The data will be refetched every 1 minutes
    },
    { userId }
  );

  if (isFetching && !conversationsData) {
    return (
      <Grid container spacing={2}>
        <Typography>Loading...</Typography>
      </Grid>
    );
  }

  if (!conversationsData || conversationsData.length === 0) {
    return (
      <Grid container spacing={2}>
        <Typography>No conversations found.</Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} textAlign={'center'} padding={1}>
        <Typography variant="h4">Messages</Typography>
      </Grid>
      {conversationsData &&
        conversationsData.map((conversation) => (
          <Grid item xs={12} key={conversation.id}>
            <Link
              key={conversation.id}
              href={`/conversations/${conversation.id}`}
              underline="none"
              color="inherit"
            >
              <Grid item xs={12}>
                <Grid display={'flex'} flexDirection="row" alignItems="center">
                  {conversation.is_read === false && (
                    <CircleIcon color={'primary'} sx={{ fontSize: 10 }} />
                  )}
                  <Grid
                    display={'flex'}
                    flexDirection="column"
                    flexGrow={1}
                    padding={2}
                  >
                    <Grid
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                      display={'flex'}
                    >
                      <Typography
                        variant="body1"
                        fontWeight={conversation.is_read ? 'normal' : 'bold'}
                        color={'primary'}
                      >
                        {conversation.title}
                      </Typography>
                      <Typography variant="caption">
                        {dayjs
                          .utc(conversation.updated_at)
                          .local()
                          .format('M/DD/YYYY h:mm A')}
                      </Typography>
                    </Grid>
                    <Typography variant="body1" sx={{ fontSize: 14 }}>
                      {conversation.last_message}
                    </Typography>
                  </Grid>
                </Grid>

                <Divider />
              </Grid>
            </Link>
          </Grid>
        ))}
    </Grid>
  );
}
